import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';

import { useRepositoryQuery } from '@mews-commander/data-access';
import { matchTimeUnitKey } from '@mews/framework';
import { isDayUse } from '@mews-commander/utils';
import { orderOrderableEntityArray } from '@mews-commander/legacy-entities/src/utils/orderableEntities';
import { isBookableService } from '@mews-commander/legacy-entities/src/ducks/servicesNew';
import { isTimeUnitWithinParentTime } from '../utils/timeUnitPeriodUtils';

export const useGetServices = (enterpriseId: string, serviceId: string) =>
    useRepositoryQuery(
        'services',
        'getAll',
        {
            enterpriseIds: [enterpriseId],
        },
        {
            select: ({ services }) => {
                const parentService = pipe(
                    services,
                    array.filter(isBookableService),
                    array.findFirst((service) => service.id === serviceId),
                    option.getOrElseW(() => undefined)
                );

                return pipe(
                    services,
                    array.filterMap((service) =>
                        isBookableService(service) &&
                        service.id !== serviceId &&
                        isTimeUnitWithinParentTime(parentService, service)
                            ? option.some(service)
                            : option.none
                    ),
                    array.map((service) => {
                        const isServiceDayUse = isDayUse(service);
                        const timeUnit = service.data.value?.timeUnitPeriod;
                        return {
                            ...service,
                            timeUnitLabelKey: timeUnit
                                ? matchTimeUnitKey({ perTimeUnit: true, isServiceDayUse, timeUnit })
                                : undefined,
                        };
                    }),
                    orderOrderableEntityArray
                );
            },
        }
    );
